<template>
    <div class="bigmap-wrap">
        <div class="title"><img src="./images/icon03.png" /> 管网数据 </div>
        <div class="distribution_map" id="distribution_map"></div>
    </div>
</template>

<script>
import BigMap from "./js/BigMap"

export default {
    name:"bigmap",
    data(){
        return {

        }
    },
    mounted(){
        // 初始化地图
        this.init_map();
    },
    methods:{
        // 初始化地图
        init_map(){
            new BigMap('distribution_map',{
                center:[120.26125332913983,30.268701108281903,],
            });
        }
    }
}
</script>

<style lang="scss">
.bigmap-wrap{
    width:100%;
    height: 100%;
    display: flex;
    flex-direction: column;

    .distribution_map{
        padding:10px;
        flex:1;
    }
}
</style>